import type { MisconceptionDefinition } from './types';
import { basisLeenwoordenMisconceptions } from './sww/basisLeenwoorden';
import { onregelmatigSterkMisconceptions } from './sww/onregelmatigSterk';
import { tegenwoordigeTijdMisconceptions } from './sww/tegenwoordigeTijd';
import { verledenTijdVoltooidDeelwoordMisconceptions } from './sww/verledenTijdVoltooidDeelwoord';
import { bijvoeglijkNieuwMisconceptions } from './sww/bijvoeglijkNieuw';
import { seedAdditionsRonde2Misconceptions } from './sww/seedAdditionsRonde2';

/**
 * SWW — Spelling werkwoorden misconcepties (barrel).
 *
 * Deze barrel concateneert zes sub-registries onder `./sww/`:
 * - `basisLeenwoorden`
 * - `onregelmatigSterk`
 * - `tegenwoordigeTijd`
 * - `verledenTijdVoltooidDeelwoord`
 * - `bijvoeglijkNieuw`
 * - `seedAdditionsRonde2`
 */
export const SWW_MISCONCEPTIONS: MisconceptionDefinition[] = [...basisLeenwoordenMisconceptions, ...onregelmatigSterkMisconceptions, ...tegenwoordigeTijdMisconceptions, ...verledenTijdVoltooidDeelwoordMisconceptions, ...bijvoeglijkNieuwMisconceptions, ...seedAdditionsRonde2Misconceptions];